import { render } from "./CreateLogisticsInfo.vue?vue&type=template&id=5989a545&scoped=true"
import script from "./CreateLogisticsInfo.vue?vue&type=script&lang=js"
export * from "./CreateLogisticsInfo.vue?vue&type=script&lang=js"

import "./CreateLogisticsInfo.vue?vue&type=style&index=0&id=5989a545&scoped=true&lang=css"
import "./CreateLogisticsInfo.vue?vue&type=style&index=1&id=5989a545&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5989a545"]])

export default __exports__